<lib-popup-toggle [icon]="previewIcon()" data-test="display-selector">
  <lib-buttons-select
    [class.hide-layout-options]="isNarrow()"
    [options]="layoutOptions"
    keyName="label"
    optionLabel="label"
    optionDataAttr="displayMode"
    [ngModel]="selectedLayout()"
    (ngModelChange)="updateSelectedLayout($event)"
  />
  <lib-buttons-select
    [class.hide-tile-options]="isListLayout() || !showTileOptions()"
    [options]="tileOptions"
    keyName="label"
    optionLabel="label"
    optionDataAttr="layout"
    [ngModel]="selectedTileOption()"
    (ngModelChange)="updateSelectedTileOption($event)"
  />
</lib-popup-toggle>
